import { css } from "@emotion/react"
import styled from "@emotion/styled"
import Image from "components/Image"

const dynamicStyles = ({ theme }) => css`
  ${`
        ${theme.breakpoints.down("lg")} {
            width: 64px;
            height: 64px;
            margin-bottom: 20px;
        }

        ${theme.breakpoints.up("lg")} {
            width: 48px;
            height: 48px;
             margin-bottom: 8px;
        }
    `}
`

const HeroCaseImage = styled(Image)`
  display: block;

  ${dynamicStyles};
`

export default HeroCaseImage
